import { Box, Typography } from "@mui/material";
import "./QuoteDiscountSummary.scss";

type Props = {
  title?: "Quote Discounts";
  monthly: number | null | undefined;
  installment: number | null | undefined;
  annual: number | null | undefined;
};

const QuoteDiscountSummary = ({ title, monthly, installment, annual }: Props) => {
  const discounts = [
    { term: "P1M", value: monthly },
    { term: "P1YM", value: installment },
    { term: "P1YA", value: annual },
  ];

  return <Box className="quote-discount-summary">
    {title && <Typography variant="subtitle2">{title}</Typography>}
    <Box className="quote-discount-values">
      {discounts.map(discount => <Box className="quote-discount-value" key={discount.term}>
        <Typography component="span" variant="caption">{discount.term}</Typography>
        <Typography component="span">{discount.value ?? 0}%</Typography>
      </Box>)}
    </Box>
  </Box>;
};

export default QuoteDiscountSummary;
